module.exports = __webpack_public_path__ + "ad89414e7ae462449624b64ca7baef7d.png";